import {
	fetchReservationTimeAll,
	fetchUserReservationList,
	cancelUserReservation,
	fetchUserReservationWaitingList,
	cancelUserReservationWaiting,
	insertUserReservationWaiting,
} from '@/api';

const namespaced = true;

const state = {
	labels: {
		step1: '',
		step2: '',
		step3: '',
		step4: '',
		step5: '',
	},
	isOpenContents: {
		step1: true,
		step2: false,
		step3: false,
		step4: false,
		step5: false,
	},
	isDisabled: {
		step1: false,
		step2: true,
		step3: true,
		step4: true,
		step5: true,
	},
	result: {
		branchName: '',
		reservationDate: '',
		reservationTime: '',
		reservationService: '',
	},
	reservationTime: [],

	userReservationList: [],
	userReservationWaitingList: [],
};

const getters = {
	reservationFormItemLabels(state) {
		return state.labels;
	},
	reservationFormItemLabel: state => stepKey => state.labels[stepKey],
	isOpenReservationFormItem: state => stepKey => state.isOpenContents[stepKey],
	isDisabledReservationFormItem: state => stepKey => state.isDisabled[stepKey],
	reservationResult(state) {
		return state.result;
	},

	userReservationList(state) {
		return state.userReservationList;
	},
	userReservationWaitingList(state) {
		return state.userReservationWaitingList;
	},
};

const mutations = {
	setReservationTimeAll(state, list) {
		state.reservationTime = list;
	},
	setReservationFormItemLabel(state, { stepKey, label }) {
		state.labels[stepKey] = label;
	},
	setOpenReservationFormItem(state, { stepKey, isOpen }) {
		state.isOpenContents[stepKey] = isOpen;
	},
	setDisabledReservationFormItem(state, { stepKey, isDisabled }) {
		state.isDisabled[stepKey] = isDisabled;
	},
	setFormData(state, data) {
		state.result = data;
	},

	setUserReservationList(state, { page, list }) {
		page === 1
			? (state.userReservationList = [...list])
			: (state.userReservationList = [...state.userReservationList, ...list]);
	},
	initUserReservationList(state) {
		state.userReservationList = [];
	},
	setUserReservationWaitingList(state, { page, list }) {
		page === 1
			? (state.userReservationWaitingList = [...list])
			: (state.userReservationWaitingList = [
					...state.userReservationWaitingList,
					...list,
			  ]);
	},
	initUserReservationWaitingList(state) {
		state.userReservationWaitingList = [];
	},
};

const actions = {
	getReservationTimeAll({ commit }, payload) {
		return fetchReservationTimeAll(payload)
			.then(response => {
				if (response.data.code === '00000')
					commit('setReservationTimeAll', response.data.list);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	getUserReservationList({ commit }, payload) {
		return fetchUserReservationList(payload)
			.then(response => {
				if (response.data.code === '00000')
					commit('setUserReservationList', response.data);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	initUserReservationList({ commit }) {
		commit('initUserReservationList');
	},
	cancelUserReservation(context, payload) {
		return cancelUserReservation(payload)
			.then(response => {
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	getUserReservationWaitingList({ commit }, payload) {
		return fetchUserReservationWaitingList(payload)
			.then(response => {
				if (response.data.code === '00000')
					commit('setUserReservationWaitingList', response.data);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	initUserReservationWaitingList({ commit }) {
		commit('initUserReservationWaitingList');
	},
	cancelUserReservationWaiting(context, payload) {
		return cancelUserReservationWaiting(payload)
			.then(response => {
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	insertReservationWaiting(context, payload) {
		return insertUserReservationWaiting(payload)
			.then(response => {
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
};

export default {
	namespaced,
	state,
	getters,
	mutations,
	actions,
};
